export default __webpack_public_path__ + "static/media/glogo.8ad2d5a4.png";